import { queryOptions } from "@tanstack/react-query";

import { getUser1 } from "@/generated/api/users";

const userQuery = ({ id }: { id: number }) =>
  queryOptions({
    queryFn: ({ signal }) => getUser1(id, { signal }),
    queryKey: ["user", id],
  });

export { userQuery };
